import axios from "axios";
import { motion } from "framer-motion";
import Cookies from "js-cookie";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ClipLoader } from "react-spinners";
import { toast } from "react-toastify";
import { API_BASE_URL } from "../config";
import useAuthStore from "../store/auth.store";
import { p2e } from "../utils";
import OTPInputV2 from "../components/auth/OTPInputV2";
import axiosInstance from "../config/axios";
import useSongStore from "../store/song.store";

const OtpActivationScreen = () => {
  const navigate = useNavigate();

  const [otpCode, setOtpCode] = useState(Array(4).fill(""));
  const [isLoading, setIsLoading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [isError, setIsError] = useState(false);

  const toneCode = useSongStore((state) => state.toneCode);

  const handleOTPComplete = async () => {
    setIsLoading(true);

    try {
      await axiosInstance.post(API_BASE_URL + "v1/activation/", {
        otp: otpCode?.join(""),
        tone_code: toneCode,
      });

      toast.success("آوای انتظار موردنظر با موفقیت فعال شد!");

      navigate("/wheel");
    } catch (error: any) {
      setIsError(true);
      toast.error("کد وارد شده معتبر نیست!");
    } finally {
      setIsLoading(false);
      setOtpCode(Array(4).fill(""));
    }
  };

  return (
    <div className="w-full h-full flex flex-col justify-center items-center text-center px-4">
      <motion.h1
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="text-black text-xl md:text-3xl font-bold leading-relaxed mb-6"
      >
        کد تایید ارسال شده را
        <br />
        وارد نمایید
      </motion.h1>

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3, duration: 0.6 }}
        className="w-full max-w-xs"
      >
        <OTPInputV2
          length={4}
          onComplete={handleOTPComplete}
          setIsDisabled={setIsDisabled}
          isError={isError}
          setIsError={setIsError}
          otp={otpCode}
          setOtp={setOtpCode}
        />
      </motion.div>

      <motion.button
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.6, duration: 0.5 }}
        onClick={handleOTPComplete}
        className="mt-6 bg-[#2a95db] text-white  min-w-[8rem] px-8 py-3 rounded-xl text-lg md:text-xl font-bold shadow-lg hover:bg-blue-600 transition"
        disabled={isDisabled}
      >
        {isLoading ? <ClipLoader color="#fff" size={24} /> : "تایید"}
      </motion.button>
    </div>
  );
};

export default OtpActivationScreen;
